import {
  STORE_INITIALIZE,
  RTD_INITIALIZE,
  MENU_ITEM_AVAILABILITY,
  MODIFIER_AVAILABILITY,
  FORCED_MODIFIER_AVAILABILITY,
} from '../constants/actionTypes';

const initialState = {
  status: {
    menu_item: {},
    modifier: {},
    forced_modifier: {},
  },
};
export const socketReducer = (state = initialState, action) => {
  switch (action.type) {
    case RTD_INITIALIZE:
    case STORE_INITIALIZE: {
      return initialState;
    }
    case MENU_ITEM_AVAILABILITY: {
      return {
        ...state,
        status: {
          ...state.status,
          menu_item: {
            ...state.status.menu_item,
            [action.id]: action.unavailableUntil,
          },
        },
      };
    }
    case MODIFIER_AVAILABILITY: {
      return {
        ...state,
        status: {
          ...state.status,
          modifier: {
            ...state.status.modifier,
            [action.id]: action.unavailableUntil,
          },
        },
      };
    }
    case FORCED_MODIFIER_AVAILABILITY: {
      return {
        ...state,
        status: {
          ...state.status,
          forced_modifier: {
            ...state.status.forced_modifier,
            [action.id]: action.unavailableUntil,
          },
        },
      };
    }
    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/socketReducer.js